import { NativeDateAdapter, MatDateFormats, DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import {Platform} from '@angular/cdk/platform';
import {Inject, Injectable, Optional} from '@angular/core';



export class AppDateAdapter extends NativeDateAdapter {
	
	
  override getMonthNames(style: 'long' | 'short' | 'narrow'): string[] {

	const DEFAULT_MONTH_NAMES = {
  'long': [
    	'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September',
   	 'Oktober', 'November', 'Dezember'
  	],
  		'short': ['Jan.', 'Feb.', 'März', 'April', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sept.', 'Okt.', 'Nov.', 'Dez.'],
  		'narrow': ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D']
	};    
    
    return DEFAULT_MONTH_NAMES[style];
  }
  
  override format(date: Date, displayFormat: Object): string {
  	 //console.log("displayFormat="+ JSON.stringify(displayFormat));
    
    if (displayFormat['month'] === 'numeric') 
    {
    	const day = date.getDate();
      const month: number = (date.getMonth() + 1);
      const year = date.getFullYear();
      return  (day<10? "0":"" ) +day+"."+ (month<10? "0":"" ) +month +"." +year;
    }
    
    if (displayFormat['month'] === 'short') 
    {
    	const day = date.getDate();
      const month = this.getMonthNames('short')[(date.getMonth())];
      const year = date.getFullYear();
      
     
      return day+" " +month +" " +year;
    }
    
    if (displayFormat['month'] === 'long') 
    {
    	const day = date.getDate();
      const month = this.getMonthNames('short')[(date.getMonth())];
      const year = date.getFullYear();
      return day+" " +month +" " +year;
    }
    
    //const options: Intl.DateTimeFormatOptions = { month: "long", day: 'numeric', year: 'numeric', hour: '2-digit', minute: "2-digit" };
    const options: Intl.DateTimeFormatOptions = { month: "long", day: 'numeric', year: 'numeric' };
   
    //const options = { year: 'numeric', month: '2-digit', day: '2-digit' } ;
	 //const options = { year: 'string' , month: 'string', day: 'string' };
	 
	 //console.log("toLocaleDateString ->" +  date.toLocaleDateString('de-DE', options));
	 //console.log("Date ->" +  date);  
	 return date.toLocaleDateString('de-DE', options);
	 //return date.toDateString();
  }
  

    override parse(value: any): Date | null 
	{
	 //console.log("Parse " + value)
    if ((typeof value === 'string') && (value.indexOf('.') > -1)) 
    {
      const str = value.split('.');
      const year = Number(str[2]);
      const month = Number(str[1]) - 1;
      const date = Number(str[0]);

		const d =new Date(year, month, date);
		//console.log("Parse " + d)
      return d;
    }
    const timestamp = typeof value === 'number' ? value : Date.parse(value);
    
    return isNaN(timestamp) ? null : new Date(timestamp);
  }  
}



export const APP_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: {  day: 'numeric' ,month: 'numeric', year: 'numeric'},
  },
  
  display: {
    dateInput: 'input',
    monthYearLabel: { year: 'numeric', month: 'numeric' },
    dateA11yLabel: { year: 'numeric', month: 'numeric', day: 'numeric'
    },
    monthYearA11yLabel: { year: 'numeric', month: 'numeric' },
  }
}
